import React, { useState, useMemo, useEffect, useCallback } from 'react';
import * as Tone from 'tone';

const MelodyPlayer = ({ sequence, tempo, notePerBeat }) => {
  const motif = useMemo(() => {
    const keys = [ 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B' ];
    let time = 0;
    const motifArray = [];
    sequence.forEach(element => {
      if (element.constructor.name === 'Note') {
        motifArray.push({ 'note' : `${keys[element.value]}${element.octave}`, 'duration' : `${1/element.duration}n`, 'time' : `${time}`, 'velocity' : element.velocity/127})
      };
      time += (60 / tempo) * (element.duration/notePerBeat);
    });
    return motifArray
  }, [sequence, tempo, notePerBeat]);

  const [isPlaying, setIsPlaying] = useState(false);

  const playMotif = useCallback(async () => {
    await Tone.start(); // Required for browser autoplay policies
    Tone.getTransport().bpm.value = tempo;

    const synth = new Tone.Synth({
      oscillator: { type: 'sine' },
      envelope: { attack: 0.1, decay: 0.2, sustain: 0.3, release: 1 }
    }).toDestination();

    const motifPart = new Tone.Part((time, value) => {
      synth.triggerAttackRelease(value.note, value.duration, time, value.velocity);
    }, motif).start();

    motifPart.start(0);
    Tone.getTransport().start();
    setIsPlaying(true);

    // Stop after one loop
    setTimeout(() => {
      Tone.getTransport().stop();
      motifPart.dispose();
      synth.dispose();
      setIsPlaying(false);
    }, (motif.length * 60000) / tempo);
  },[motif, tempo]);

  useEffect(() => {
    if (!isPlaying) {
      playMotif();
    }
  }, [isPlaying, playMotif]);

  return (
    <div>
      <button onClick={() => playMotif()} disabled={isPlaying}>
        Play Motif
      </button>
    </div>
  );
};

export default MelodyPlayer;